<template>
    <modal :show="show" class="white-content" @update:show="$emit('update:show', $event)">
      <h3 class="card-title">{{ $t('common.changeDates') }}</h3>
      <div class="row">
        <div class="col-12">
          <div class="calendar d-flex align-items-center">
            <div class="d-flex align-items-center" style="flex: 1;">
              <el-date-picker
                v-model="localUpdatedReservationDate"
                class="flex-grow-1 form-group"
                type="date"
                :placeholder="$t('common.from')"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
              />
            </div>
            <span class="mx-2">-</span>
            <div class="d-flex align-items-center" style="flex: 1;">
              <el-date-picker
                v-model="localUpdatedUnreservationDate"
                class="flex-grow-1 form-group"
                type="date"
                :placeholder="$t('common.to')"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <material-checkbox
            id="setPriceZero"
            v-model="localSetPriceZero"
          >
            {{ $t('common.totalAmount') }} 0kr
          </material-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-end">
          <material-button type="standard" fill @click="$emit('submit')">{{ $t('common.submit') }}</material-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import { ElDatePicker } from 'element-plus';
  import Modal from './Modal.vue';
  import MaterialCheckbox from '../MaterialCheckbox.vue';
  import MaterialButton from '../MaterialButton.vue';
  
  export default {
    components: { Modal, ElDatePicker, MaterialCheckbox, MaterialButton },
    props: {
      show: { type: Boolean, required: true },
      updatedReservationDate: { type: [String, null], required: true },
      updatedUnreservationDate: { type: [String, null], required: true },
      setPriceZero: { type: Boolean, required: true }
    },
    emits: ['update:show', 'update:updatedReservationDate', 'update:updatedUnreservationDate', 'update:setPriceZero', 'submit'],
    data() {
      return {
        localUpdatedReservationDate: this.updatedReservationDate,
        localUpdatedUnreservationDate: this.updatedUnreservationDate,
        localSetPriceZero: this.setPriceZero
      };
    },
    watch: {
      show(newVal) {
        if (newVal) {
          this.localUpdatedReservationDate = this.updatedReservationDate;
          this.localUpdatedUnreservationDate = this.updatedUnreservationDate;
          this.localSetPriceZero = this.setPriceZero;
        }
      },
      localUpdatedReservationDate(newVal) { this.$emit('update:updatedReservationDate', newVal); },
      localUpdatedUnreservationDate(newVal) { this.$emit('update:updatedUnreservationDate', newVal); },
      localSetPriceZero(newVal) { this.$emit('update:setPriceZero', newVal); }
    }
  };
  </script>